module.exports = __webpack_public_path__ + "static/media/fa-regular-400.7f2e0f11.svg";